export default state => {
	return state.claims !== null && state.nfts !== null && state.user.data !== null;
};
